import { getAPIUrl } from '../helpers/App';

export const APIgetShares = params => (
  window.axios.get(getAPIUrl('/shares'), { params })
    .then(response => (response))
);

export const APIgetShare = (shareUuid, params) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}`), { params })
    .then(response => (response))
);

export const APIgetShareInfo = shareUuid => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/info`))
    .then(response => (response))
);

let getShareFilesRequestCancel = null;
export const APIgetShareFiles = (shareUuid, params) => {
  if (getShareFilesRequestCancel !== null) {
    getShareFilesRequestCancel.cancel('Operation canceled due to new request.');
  }
  getShareFilesRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/shares/${shareUuid}/files`), {
    cancelToken: getShareFilesRequestCancel.token,
    params,
  })
    .then(response => (response));
};

let getShareCollectionsRequestCancel = null;
export const APIgetShareCollections = (shareUuid, params) => {
  if (getShareCollectionsRequestCancel !== null) {
    getShareCollectionsRequestCancel.cancel('Operation canceled due to new request.');
  }
  getShareCollectionsRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/shares/${shareUuid}/collections`), {
    cancelToken: getShareCollectionsRequestCancel.token,
    params,
  })
    .then(response => (response));
};

export const APIauthShare = (shareUuid, data) => (
  window.axios.post(getAPIUrl(`/shares/${shareUuid}/auth`), data)
    .then(response => (response))
);

export const APIcreateShare = share => (
  window.axios.post(getAPIUrl('/shares'), share)
    .then(response => (response))
);

export const APIupdateShare = (shareUuid, share) => (
  window.axios.patch(getAPIUrl(`/shares/${shareUuid}`), share)
    .then(response => (response))
);

export const APIupdateShareFile = (shareUuid, fileUuid, file) => (
  window.axios.patch(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}`), file)
    .then(response => (response))
);

export const APIgetShareFileStatuses = (shareUuid) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/statuses`))
    .then(response => (response))
);

export const APIdeleteShare = shareUuid => (
  window.axios.delete(getAPIUrl(`/shares/${shareUuid}`))
    .then(response => (response))
);

export const APIgetShareSummary = (params) => (
  window.axios.post(getAPIUrl('/shares/summary'), params)
    .then(response => (response))
);

export const APIcreateShareDownload = (shareUuid, params) => (
  window.axios.post(getAPIUrl(`/shares/${shareUuid}/downloads`), params)
    .then(response => (response))
);

export const APIfetchShareDetails = (shareUuid, params) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/details`), { params })
    .then(response => (response))
);

export const APIgetShareDownload = (shareUuid, downloadUuid) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/downloads/${downloadUuid}`))
    .then(response => (response))
);

export const APIgetShareFileLikes = (shareUuid, fileUuid) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/likes`))
    .then(response => (response))
);

export const APIlikeShareFile = (shareUuid, fileUuid) => (
  window.axios.post(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/likes`))
    .then(response => (response))
);

export const APIunlikeShareFile = (shareUuid, fileUuid) => (
  window.axios.delete(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/likes`))
    .then(response => (response))
);

export const APIgetShareCollectionLikes = (shareUuid, collectionUuid) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/collections/${collectionUuid}/likes`))
    .then(response => (response))
);

export const APIlikeShareCollection = (shareUuid, collectionUuid) => (
  window.axios.post(getAPIUrl(`/shares/${shareUuid}/collections/${collectionUuid}/likes`))
    .then(response => (response))
);

export const APIunlikeShareCollection = (shareUuid, collectionUuid) => (
  window.axios.delete(getAPIUrl(`/shares/${shareUuid}/collections/${collectionUuid}/likes`))
    .then(response => (response))
);

export const APIregisterShareFileView = (shareUuid, fileUuid) => (
  window.axios.post(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/views`))
    .then(response => (response))
);

export const APIgetSharesUsers = params => (
  window.axios.get(getAPIUrl('/shares/users'), { params })
    .then(response => (response))
);

export const APIgetSharesUsersMentions = (shareUuid, params) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/users/mentions`), { params })
    .then(response => (response))
);

export const APIgetShareFilePublicUrl = (shareUuid, fileUuid) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/public`))
    .then(response => (response))
);

export const APIgetShareCollection = (shareUuid, collectionUuid) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/collections/${collectionUuid}`))
    .then(response => (response))
);

export const APIgetShareSettings = (params) => (
  window.axios.get(getAPIUrl('/shares/settings'), { params })
    .then(response => (response))
);

export const APIupdateShareSettings = (params) => (
  window.axios.post(getAPIUrl('/shares/settings'), params)
    .then(response => (response))
);

export const APIcreateShareTemplate = (params) => (
  window.axios.post(getAPIUrl('/shares/settings/template'), params)
    .then(response => (response))
);

export const APIloadShareTerms = shareUuid => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/load_terms`))
    .then(response => (response.data))
);

export const APIacceptShareTerms = shareUuid => (
  window.axios.patch(getAPIUrl(`/shares/${shareUuid}/accept_terms`))
    .then(response => (response.data))
);

export const APIfetchAcceptedTermsOfService = (shareUuid, params) => (
  window.axios.get(getAPIUrl(`/shares/${shareUuid}/accepted_terms`), { params })
    .then(response => (response))
);
